module.exports = __webpack_public_path__ + "img/seccion1.6.afc6f964.png";